export default {
  REASON: "Reason",
  REASON_PLACEHOLDER: "Choose a reason",
  REASON_DETAIL: "Details",
  REASON_DETAIL_PLACEHOLDER: "Add details if needed",
  REASON_DETAIL_REQUIRED_HELP: "Details are required when the reason is “Other”.",
  CONFIRM: "Confirm",

  CANCELLATION_REASONS: {
    WRONG_QUANTITY: "Wrong quantity",
    NOT_RECEIVED: "Products not received",
    DUPLICATE: "Duplicate invoice",
    WRONG_DAY: "Wrong day",
    OTHER: "Other",
  },

  NON_RECEPTION_REASONS: {
    OPENING_DELAYED: "Cafeteria opening delayed",
    CAFETERIA_CLOSED: "Cafeteria closed that day",
    SCHOOL_CLOSED: "School closed (holiday, storm, professional day)",
    NOT_DELIVERED: "Delivery not made by the production",
    CANCELED_WITH_PRODUCTION: "Day canceled by agreement with the production",
    ORDER_ERROR: "Day ordered by mistake",
    OTHER: "Other",
  },

  REJECTION_REASONS: {
    CAPACITY: "Not enough production capacity",
    PRODUCTS_UNAVAILABLE: "Products unavailable",
    WRONG_CONTENT: "Wrong order content",
    OTHER: "Other",
  },

  DISCREPANCIES: {
    QUANTITY_DIFFERS: "Quantity differs",
    NOT_DELIVERED: "Ordered, not received",
    NOT_ORDERED: "Received, not ordered",
  },

  DISCREPANCIES_TITLE: "Discrepancies between order and reception",
  DISCREPANCIES_HELP:
    "This reception differs from the ordered day: it is waiting for the production establishment to accept it. A matching reception is accepted automatically.",
  DISCREPANCY: "Discrepancy",
  ORDERED: "Ordered",
  RECEIVED: "Received",

  AUTO_ACCEPTED: "Automatically accepted",
  AUTO_ACCEPTED_HELP:
    "The reception matched exactly what was ordered for that day: no acceptance was needed.",

  CANCEL_INVOICE_TITLE: "Cancel the internal invoice",
  CANCEL_INVOICE_HELP:
    "Canceling removes the invoice from both weekly reports and reopens the day. The other school is notified by e-mail, with the reason.",
  REJECT_ORDER_TITLE: "Reject the internal order",
  REJECT_ORDER_HELP:
    "The satellite establishment is notified by e-mail that its week will not be produced, with the reason.",

  CANCELED_BY: "Canceled by",
  CANCELED_AT: "Canceled on",
  CANCELLATION_REASON: "Cancellation reason",
  NON_RECEPTION: "Day not received",
  NON_RECEPTION_HELP:
    "Nothing was received for this ordered day: this 0 $ invoice closes it. The production establishment accepts it once it has read the reason, or cancels it to reopen the day.",
  NON_RECEPTION_REASON: "Non-reception reason",
  REJECTED_BY: "Rejected by",
  REJECTED_AT: "Rejected on",
  REJECTION_REASON: "Rejection reason",

  LOCKED_BY_VALIDATED_WEEKLY_REPORT:
    "Not possible: a weekly report covering that day is already validated.",
};
